import { render, staticRenderFns } from "./MultiPointOutcomeEditor.vue?vue&type=template&id=a2fcc040&"
import script from "./MultiPointOutcomeEditor.vue?vue&type=script&lang=ts&"
export * from "./MultiPointOutcomeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports